import { render, staticRenderFns } from "./textualCriticism.vue?vue&type=template&id=3254650c"
import script from "./textualCriticism.vue?vue&type=script&lang=js"
export * from "./textualCriticism.vue?vue&type=script&lang=js"
import style0 from "./textualCriticism.vue?vue&type=style&index=0&id=3254650c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports